import {
  AxiosResponse,
} from 'axios';
import {
  paths,
} from '../openapi.ts';
import {
  axiosClientRestPT9800,
} from '@/api/client';
// @ts-ignore: - potentially unused import
import {
  // @ts-ignore: - potentially unused import
  TApiPayload,
  // @ts-ignore: - potentially unused import
  interpolateUrl,
} from './_utils';
// @ts-ignore: - potentially unused import
import {
  QueryKey,
} from '@tanstack/vue-query';
import {
  resolvePt9800TemplatesInRequest,
} from '@/utils/pt9800';
import {
  getUserMenuItemsEndpoint,
} from './me.endpoints.ts';

export * from './me.endpoints.ts';

export type TGetUserMenuItemsPath = paths['/{ptDbId}/me']['get']['parameters']['path'];
export type TGetUserMenuItemsPayload = TApiPayload<TGetUserMenuItemsPath, undefined, undefined>;
export type TGetUserMenuItemsResponse200 = paths['/{ptDbId}/me']['get']['responses']['200']['content']['*/*'];
export type TGetUserMenuItemsResponse = TGetUserMenuItemsResponse200;
export const getUserMenuItemsQueryKey = (ptDbId: QueryKey[number]): QueryKey => ([...["me"], ptDbId]);
export function getUserMenuItems(payload: TGetUserMenuItemsPayload, abortSignal?: AbortSignal): Promise<AxiosResponse<TGetUserMenuItemsResponse>> {
  return resolvePt9800TemplatesInRequest(axiosClientRestPT9800.get(interpolateUrl(getUserMenuItemsEndpoint, payload.path), { signal: abortSignal }));
}

